module.exports = __webpack_public_path__ + "Flag-662.8a767e8095739102e68669c67c1dcc45.svg";